import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import classNames from 'classnames'
import ToggleButtonWithIcon from '../ToggleButtonWithIcon'
import getTempRangeDisplay from './getTempRangeDisplay'
import weatherTypes from '../../enums/weatherTypes'
import serverTimestamp from '../../utilities/Data/serverTimestamp'
import styles from './PostDetailsDisplay.icss'

const cap = str => str.charAt(0).toUpperCase() + str.slice(1)
const getDateFromTimestamp = timestamp => (timestamp && timestamp.toDate ? timestamp.toDate() : new Date(timestamp))

const eventTimes = (post) => {
	const date = moment(getDateFromTimestamp(serverTimestamp(post.dateTimestamp)))
	const timeFormat = 'hh:mma ddd Do MMM'
	const start = date.format(timeFormat)
	if (post.timeTakenHours) {
		date.add(post.timeTakenHours, 'h')
	}
	if (post.timeTakenMinutes) {
		date.add(post.timeTakenMinutes, 'm')
	}
	const end = date.format(timeFormat)
	return { start, end }
}

class PostDetailsDisplay extends Component {
	render() {
		const { post } = this.props
		const weatherIconProps = {
			ignoreClick: true,
			classNameOn: styles.weatherOn,
			classNameOff: styles.weatherOff
		}

		const times = eventTimes(post)
		return (
			<>
				<section className={styles.conditions}>
					<div>
						<div className={classNames(styles.detailsLabel, styles.conditionsLabel)}>{this.context.translate('Conditions')}</div>
					</div>
					<div className={styles.weatherSurround}>
						{Object.keys(weatherTypes).map(wt => (
							<ToggleButtonWithIcon
								key={wt}
								title={weatherTypes[wt].name}
								value={post[wt]}
								iconNameOff={`black${cap(wt)}`}
								iconNameOn={`black${cap(wt)}`}
								{...weatherIconProps}
							/>
						))}
					</div>
					<div>
						<div className={classNames(styles.detailsLabel, styles.conditionsLabel)}>{this.context.translate('Temperature range')}</div>
						{getTempRangeDisplay(post)}
					</div>
				</section>

				<section className={styles.details}>
					<div className={styles.detailsLabel}>{this.context.translate('Where')}</div>
					<div className={styles.detailsValue}>{post.location || this.context.translate('Location not specified')}</div>
				</section>

				<section className={styles.times}>
					<section className={styles.details}>
						<div className={styles.detailsLabel}>{this.context.translate('Start')}</div>
						<div className={styles.detailsValue}>{times.start}</div>
					</section>

					<section className={styles.details}>
						<div className={styles.detailsLabel}>{this.context.translate('End')}</div>
						<div className={styles.detailsValue}>{times.end}</div>
					</section>
				</section>
			</>
		)
	}
}

PostDetailsDisplay.contextTypes = {
	translate: PropTypes.func
}

PostDetailsDisplay.propTypes = {
	post: PropTypes.object // eslint-disable-line react/forbid-prop-types
}

PostDetailsDisplay.defaultProps = {
	post: undefined
}

export default PostDetailsDisplay



// WEBPACK FOOTER //
// ./src/components/Item/PostDetailsDisplay.jsx